<page-title text="Logout | BitOasis" i18n-text="@@pageTitle.logout"></page-title>
<auth-logout></auth-logout>